import { mapModes } from 'client/utils/constants/appStates';
const { DEFAULT, DRAWING, MODIFYING, AOI, ADDING_OBSERVATION } = mapModes;

export const VALID_MODES = [
    [DEFAULT, AOI],
    [DEFAULT, AOI, ADDING_OBSERVATION],
    [DEFAULT, DRAWING],
    [AOI, DRAWING],
    [AOI, DRAWING, MODIFYING],
    [AOI, MODIFYING]
];
